import { axiosRequest } from '@/util/axios-request';

// 打卡设置列表页
export var getAttachmentLlist = function getAttachmentLlist(data) {
  return axiosRequest({
    url: '/web/attendance/attachment_list',
    data: data
  });
};
// 考勤群组列表
export var getAttendanceSettingList = function getAttendanceSettingList(data) {
  return axiosRequest({
    url: '/web/attendance/attendance_setting_list',
    data: data
  });
};
// 获取全部群组列表
export var getAllSettingList = function getAllSettingList(data) {
  return axiosRequest({
    url: '/web/attendance/all_setting_list',
    data: data
  });
};
// 清除底片
export var delAttchment = function delAttchment(data) {
  return axiosRequest({
    url: '/web/attendance/del_attachment',
    data: data
  });
};
// 查看员工考勤规则

export var querySettingRule = function querySettingRule(data) {
  return axiosRequest({
    url: '/web/attendance/attendance_setting_info',
    data: data
  });
};

// 编辑群组规则
export var editSettings = function editSettings(data) {
  return axiosRequest({
    url: '/web/attendance/edit_setting',
    data: data
  });
};

// 删除考勤规则
export var delSetting = function delSetting(data) {
  return axiosRequest({
    url: '/web/attendance/del_setting',
    data: data
  });
};
// 查看考勤组详情
export var getSettingInfo = function getSettingInfo(data) {
  return axiosRequest({
    url: '/web/attendance/setting_info',
    data: data
  });
};

// 考勤统计列表
export var getAttendance = function getAttendance(data) {
  return axiosRequest({
    url: '/web/statistics/attendance',
    data: data
  });
};

// 添加考勤组
export var addSetting = function addSetting(data) {
  return axiosRequest({
    url: '/web/attendance/add_setting',
    data: data
  });
};

// 检查当前登录用户是否在考勤组/班次负责人范围内
export var checkSupervisor = function checkSupervisor(data) {
  return axiosRequest({
    url: '/web/attendance/checkSupervisor',
    data: data
  });
};

// 导出考勤统计表
export var attendanceExcel = function attendanceExcel(data) {
  return axiosRequest({
    url: '/web/statistics/attendanceExcel',
    data: data
  });
};

// 保存ph公休日
export var savePhday = function savePhday(data) {
  return axiosRequest({
    url: '/web/attendance/save_ph_days',
    data: data
  });
};

// 获取ph公休日
export var getPhday = function getPhday(data) {
  return axiosRequest({
    url: '/web/attendance/ph_days',
    data: data
  });
};

// 排班-详情
export var round_info = function round_info(data) {
  return axiosRequest({
    url: '/web/attendance/round_info',
    data: data
  });
};

// 排班-添加班次
export var round_add_shift = function round_add_shift(data) {
  return axiosRequest({
    url: '/web/attendance/round_add_shift',
    data: data
  });
};

// 排班-周期-添加
export var round_edit_cycle = function round_edit_cycle(data) {
  return axiosRequest({
    url: '/web/attendance/round_edit_cycle',
    data: data
  });
};

// 排班-周期-选中分组
export var round_sel_cycle_group = function round_sel_cycle_group(data) {
  return axiosRequest({
    url: '/web/attendance/round_sel_cycle_group',
    data: data
  });
};

// 班次-周期-分组人员信息
export var round_group_staff_info = function round_group_staff_info(data) {
  return axiosRequest({
    url: '/web/attendance/round_group_staff_info',
    data: data
  });
};

// 排班-周期-分组-添加人员
export var round_group_add_staff = function round_group_add_staff(data) {
  return axiosRequest({
    url: '/web/attendance/round_group_add_staff',
    data: data
  });
};

// 班次-周期-生成日历之前的校验
export var round_group_check_staff = function round_group_check_staff(data) {
  return axiosRequest({
    url: '/web/attendance/round_group_check_staff',
    data: data
  });
};

// 排班-导出
export var exportStaffShift = function exportStaffShift(data) {
  return axiosRequest({
    url: '/web/attendance/exportStaffShift',
    data: data
  });
};

// 排班-批量导出、修改模板下载
export var downloadStaffShiftTpl = function downloadStaffShiftTpl(data) {
  return axiosRequest({
    url: '/web/attendance/downloadStaffShiftTpl',
    data: data
  });
};

// 排班-批量导出、修改上传excel
export var updateStaffShift = function updateStaffShift(data) {
  return axiosRequest({
    url: '/web/attendance/updateStaffShift',
    data: data
  });
};

// 排班-给人员添加班次-按天排班
export var round_add_staff_shift = function round_add_staff_shift(data) {
  return axiosRequest({
    url: '/web/attendance/round_add_staff_shift',
    data: data
  });
};

// 排班-给人员添加班次-按周期排班
export var round_add_staff_shift_cycle = function round_add_staff_shift_cycle(data) {
  return axiosRequest({
    url: '/web/attendance/round_add_staff_shift_cycle',
    data: data
  });
};

// 排班-给人员添加班次-按周期排班
export var round_staff_info = function round_staff_info(data) {
  return axiosRequest({
    url: '/web/attendance/round_staff_info',
    data: data
  });
};

// 考勤统计详情
export var attendanceDetail = function attendanceDetail(data) {
  return axiosRequest({
    url: '/web/statistics/attendanceDetail',
    data: data
  });
};

// 考勤详情-管理员修改某员工某日班次
export var attendanceDailyShiftEdit = function attendanceDailyShiftEdit(data) {
  return axiosRequest({
    url: '/web/statistics/attendance_daily_shift_edit',
    data: data
  });
};

// 考勤详情-管理员设置某员工某日为休息日
export var attendanceDailyRestDaySet = function attendanceDailyRestDaySet(data) {
  return axiosRequest({
    url: '/web/statistics/attendance_daily_rest_day_set',
    data: data
  });
};

// 考勤详情-管理员取消某员工某日的休息日
export var attendanceDailyRestDayCancel = function attendanceDailyRestDayCancel(data) {
  return axiosRequest({
    url: '/web/statistics/attendance_daily_rest_day_cancel',
    data: data
  });
};

// 请假统计详情
export var leaveDetail = function leaveDetail(data) {
  return axiosRequest({
    url: '/web/statistics/attendanceLeaveDetail',
    data: data
  });
};

// 统计加班详情
export var attendanceOvertimeDetail = function attendanceOvertimeDetail(data) {
  return axiosRequest({
    url: '/web/statistics/attendanceOvertimeDetail',
    data: data
  });
};

// 假期列表
export var holidayList = function holidayList(params) {
  return axiosRequest({
    url: '/web/holiday/list',
    params: params
  });
};
export var getHolidays = function getHolidays() {
  return axiosRequest({
    url: '/web/attendance/holidays'
  });
};

// 添加公共假期
export var holidayAdd = function holidayAdd(data) {
  return axiosRequest({
    url: '/web/holiday/add',
    data: data
  });
};

// 编辑公共假期
export var holidayEdit = function holidayEdit(data) {
  return axiosRequest({
    url: '/web/holiday/edit',
    data: data
  });
};

// 公共假期详情
export var holidayDetail = function holidayDetail(data) {
  return axiosRequest({
    url: '/web/holiday/detail',
    data: data
  });
};

// 删除公共假期规则
export var holidayDelete = function holidayDelete(data) {
  return axiosRequest({
    url: '/web/holiday/delete',
    data: data
  });
};

// 获取年份
export var yearList = function yearList(data) {
  return axiosRequest({
    url: '/web/statistics/yearList',
    data: data
  });
};

// 获取已选员工去重之后的总数
export var countStaffs = function countStaffs(data) {
  return axiosRequest({
    url: '/web/leave/countStaffs',
    data: data
  });
};